import { Button } from 'utils/Button';

export const ReusableSection = ({
  image,
  altText,
  title,
  content,
  buttonText,
  buttonLink
}) => {
  return (
    <div className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-10 xl:px-0 space-y-8 xl:space-y-0 grid xl:grid-cols-2 xl:max-w-[1400px] mx-auto relative xl:left-20">
      <img
        src={image}
        className="w-full max-w-[700px] mx-auto h-[300px] sm:h-[350px] md:h-[400px] xl:h-max object-cover rounded-lg xl:rounded-none"
        alt={altText}
        loading="lazy"
      />
      <div className="max-w-[700px] mx-auto text-center xl:text-left border-4 sm:border-6 md:border-8 h-max p-6 sm:p-8 border-blue-600 border-opacity-35 relative bg-white bg-opacity-80 xl:-left-36 xl:top-1/2 xl:-translate-y-1/2 flex flex-wrap rounded-lg xl:rounded-none">
        <h2 className="mx-auto mb-6 sm:mb-8 text-xl sm:text-2xl font-semibold xl:mx-0">
          {title}
        </h2>
        {content.map((paragraph, index) => (
          <p
            key={index}
            className={`leading-relaxed text-sm sm:text-base ${
              index === content.length - 1
                ? 'pb-8 sm:pb-10 pt-0'
                : 'mb-4 sm:mb-6'
            }`}>
            {paragraph}
          </p>
        ))}
        <Button
          text={buttonText}
          to={buttonLink}
          classname="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 xl:right-8 text-sm sm:text-base"
        />
      </div>
    </div>
  );
};
